import React, { Fragment, useState } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../../components/header_logged'
import Footer from '../../../../../components/footer'
import Head from '../../../../../components/head';
import Listar from '../../../../../components/auth/institucional/locais/listar'


function ListarLocaisScreen() {

    return (
        <Fragment>
            <Head titulo="Listagem de Órgãos Municipais em Macuco" />
            <HeaderLogged />
            <Container>
               <Listar />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ListarLocaisScreen;